import { textStrings } from "../textStrings.constants";

export const googleAnalyticsPageViewConstants = {
  PAGE_VIEW: "pageview",
  LOGIN: "Login",
  CONFIRM_PASSWORD: "Confirm Password",
  EMAIL_VERIFICATION: "Email Verification",
  BRANDS: "Brands",
  PROFILE: "Profile",
  USER_PROFILE: textStrings.USER_PROFILE,
  GROUPS: "Groups",
  SETTINGS: "Settings",
  PERFORMANCE: "Performance",
  BRAND_PERFORMANCE: "Brand Performance",
  SURVEY_PROFILE: "Survey Profile",
  BRAND_STORES: "Brand Stores",
  ACTIVITY_LOGS: "Activity Logs",
  THEME_SETTINGS: "Theme Settings",
  CUSTOMER_SURVEY: "Customer Survey",
  USER_PERMISSIONS: "User Permissions",
  CAMPAIGN_METRICS: "Campaign Metrics",
  SURVEY_QUESTIONS: "Survey Questions",
  GOOGLE_SOCIAL_LINK: "Google Social Link",
  CONSUMER_RESPONSES: "Consumer Responses",
  PREVIEW_SURVEY: "Preview Survey",
  GROUP_STORES: "Group Stores",
  GUEST_SENTIMENT: "Guest Sentiment",
  GROUP_PERFORMANCE: "Group Performance",
  MANAGERS: "Managers",
  MANAGER_PERFORMANCE: "Manager Performance",
  MANAGER_STORES: "Manager Stores",
  GOOGLE_REVIEW: "GOOGLE_REVIEW",
  SURVEY_VIEW: "Survey Page View",
  SURVEY_SUBMIT: "Survey Submit",
  PERFORMANCE_VIEW: "Performance Page View",
  ANALYTICS_TRACK_ERROR: "Failed to send page view to Google Analytics",
};
